"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["Text"] = "Text";
    NotificationType["Email"] = "Email";
    NotificationType["Both"] = "Both";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
//# sourceMappingURL=base.js.map